import { render, staticRenderFns } from "./TheHeaderBottom.vue?vue&type=template&id=5b524adb&"
import script from "./TheHeaderBottom.vue?vue&type=script&lang=js&"
export * from "./TheHeaderBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports